import ProgressBar from 'carbon-components-react/lib/components/ProgressBar';
import { OptionsInterface, QuestionInterface } from '../../../lib/type';
import './Question.scss';
import { useContext, useState } from 'react';
import { layoutContext } from '../../LeaderAssesssment';
import { Button } from 'carbon-components-react';
import { ArrowRight20 } from '@carbon/icons-react';
import { Scenario } from '../../../data/constants';

interface questionsProps {
  contents: QuestionInterface;
  totalOfQuestions: number;
  qNextBtn: object;
  lastQuestion: number;
}

const Question = (questionsProps: questionsProps) => {
  const { contents, totalOfQuestions, qNextBtn, lastQuestion } = questionsProps;
  const {
    selectedOption,
    setSelectedOption,
    setCurrentQuestion,
    currentQuestion,
    setOptionValeu,
    optionValue,
    setScore,
    score,
    setCurrentScenario,
  } = useContext(layoutContext);

  const [desabled, setDesabled] = useState(true);

  const handleClick = (option: OptionsInterface) => {
    const { optionId, value } = option;
    setSelectedOption(optionId);
    setDesabled(false);
    setOptionValeu(value);
  };

  const handleNext = (currentNumber: number, currentScore: number) => {
    setDesabled(true);
    setScore((currentScore += optionValue));
    if (currentNumber === lastQuestion) {
      setCurrentScenario(Scenario.results);
    } else {
      setCurrentQuestion((currentNumber += 1));
    }
  };

  const handleKeys = (key: any, option: OptionsInterface) => {
    if (key === 'Enter' || key === 'Spacebar' || key === ' ') {
      handleClick(option);
    }
  };

  return (
    <div className="leadership-assesssment__question bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
      <ProgressBar
        label={`${contents.questionNumber} of ${totalOfQuestions}`}
        value={(contents.questionNumber - 1) / totalOfQuestions}
        max={1}
        className="leadership-assesssment__question-progress"
      />
      <h1 className="leadership-assesssment__question-title">{`${contents.questionNumber}. ${contents.title.props.defaultMessage}`}</h1>
      <h4 className="leadership-assesssment__question-subTitle">
        {contents.subTitle}
      </h4>
      <div className="leadership-assesssment__question-options">
        {contents.options.map((option, i) => {
          return (
            <p
              className={
                option.optionId === selectedOption
                  ? 'leadership-assesssment__question-option-selected leadership-assesssment__question-option'
                  : 'leadership-assesssment__question-option'
              }
              onClick={() => handleClick(option)}
              tabIndex={i + 1}
              onKeyUp={(e: any) => handleKeys(e.key, option)}
            >
              {option.copy}
            </p>
          );
        })}
      </div>
      <div className="leadership-assesssment__question-btn-container">
        <Button
          className="leadership-assesssment__question-btn"
          disabled={desabled}
          onClick={() => handleNext(currentQuestion, score)}
        >
          {qNextBtn}
          <ArrowRight20 />
        </Button>
      </div>
    </div>
  );
};

export default Question;
